import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { IApiResponse } from "../../../../@types/api-response.type";
import { IPosition } from "../../../../@types/position.type";
import { getPositionById } from "../../../../services/api/positions/PositionsService";
import { FormPositions } from "../components/FormPositions";
import { useSyncActive } from "../../../../utils/useSyncActive";

export const UpdatePosition: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [position, setPosition] = useState<IPosition>({} as IPosition);
  const { id } = useParams();
  const navigate = useNavigate();

  const isSyncActive = useSyncActive();

  useEffect(() => {
    async function fechPositionById() {
      try {
        setLoading(true);

        if (!id) {
          toast.error("ID do Centro de Custo não fornecido!");
          navigate("/*");
          return;
        }

        const response = (await getPositionById(
          id
        )) as IApiResponse<IPosition>;

        if (!response.result) {
          toast.error("Função não encontrada!");
          navigate("/*");
          return;
        }

        setPosition(response.result);
      } catch (error) {
        console.log(error);
        toast.error("Erro ao carregar a Função!");
      } finally {
        setLoading(false);
      }
    }

    fechPositionById();
  }, [id]);

  return (
    <>
      {loading ? (
      <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress size={100} />
      </div>
      ) : (
        <div>
          <FormPositions pageType="update" positionsData={position} isSyncActive={isSyncActive} />
        </div>
      )}
    </>
  );
};
